import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IntakemoduleRoutingModule } from './intakemodule-routing.module';
import { IntakeComponent } from './intake/intake.component';
import { AllergyComponent } from './allergy/allergy.component';
import { MedicationComponent } from './medication/medication.component';
import { FamilyHistoryComponent } from './family-history/family-history.component';
import { SocialHistoryComponent } from './social-history/social-history.component';
import { PastSurgicalHistoryComponent } from './past-surgical-history/past-surgical-history.component';
import { PostHospitalizationComponent } from './post-hospitalization/post-hospitalization.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'

@NgModule({
  declarations: [
    IntakeComponent,
    AllergyComponent,
    MedicationComponent,
    FamilyHistoryComponent,
    SocialHistoryComponent,
    PastSurgicalHistoryComponent,
    PostHospitalizationComponent
  ],
  imports: [
    CommonModule,
    IntakemoduleRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatAutocompleteModule,
    MatInputModule,
    NgbModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ]
})
export class IntakemoduleModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
